import { LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM } from '@opendoor/auth-fe';

// Captured at module import time, before any history.replaceState calls.
// This allows authorization error handlers to reference the original URL even
// after useStripAccessTokenOnAuth has removed the token from window.location.
const _initialPathname = typeof window !== 'undefined' ? window.location.pathname : '';
const _initialToken =
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get(LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM)
    : null;

/**
 * The full initial page URL before any history manipulation.
 * Used to reconstruct login-lite redirect URLs after the access_token
 * has been stripped from window.location by useStripAccessTokenOnAuth.
 */
export const initialLoginLiteUrl: string =
  typeof window !== 'undefined' ? window.location.href : '';

/**
 * Returns the login-lite access_token captured at page load, but only while still
 * on the same route (no SPA navigation). Returns null after navigation or if no
 * token was present in the initial URL.
 *
 * Used as a fallback when the token has been stripped from window.location but
 * an authorization failure still needs to trigger a login-lite redirect.
 */
export const getInitialLoginLiteToken = (): string | null => {
  if (!_initialToken || typeof window === 'undefined') return null;
  return window.location.pathname === _initialPathname ? _initialToken : null;
};
